import React from 'react';
import { Card, Typography, Grid, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as Green } from 'assets/icons/green.svg';
import { ReactComponent as Yellow } from 'assets/icons/yellow.svg';
import { ReactComponent as Red } from 'assets/icons/red.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrowDown.svg';

import {
  displayFlex,
  displayFlexColumn,
  fontsize10,
  fontsize15,
  fontsize32,
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { Link } from 'react-router-dom';
import { medium } from 'component/ForecastCard/ForecastCard.style';
import { centerContent, forCastCard, predValue } from './PredicationCard.style';
import { useTheme } from '@emotion/react';
import { RateIcon } from 'component/ForecastCard/ForecastCard';

function PredicationCard(props) {
  const { title, data } = props;
  const theme = useTheme();
  const matchesxl = useMediaQuery(theme.breakpoints.down('xl'));
  return (
    <Card sx={[forCastCard, { height: '98%' }]}>
      <Typography sx={poppins600}>{title}</Typography>
      <Typography
        sx={displayFlex}
        style={{
          padding: '5px 10px 13px 10px',
          alignItems: 'center',
          justifyContent: matchesxl ? 'center' : 'left',
          width: '100%',
        }}
      >
        <Typography sx={{ ...poppins400, ...fontsize15 }}>To</Typography>
        <Typography marginTop={-0.5} sx={predValue}>
          <Typography sx={{ ...poppins500, ...fontsize32 }}>
            {data?.pricePrediction1 || '$ 0'}
          </Typography>
          <Typography sx={{ ...poppins500, ...fontsize32 }}>
            {data?.pricePrediction2 || '$ 0'}
          </Typography>
        </Typography>
      </Typography>
      <Grid
        sx={centerContent}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          textAlign: 'revert',
          justifyContent: 'space-between',
          backgroundColor: '#FBFAFE',
          padding: '5px 0px',
          marginBottom: '10px',
        }}
      >
        <Grid
          xs={3}
          style={{
            alignItems: 'center',
          }}
          sx={displayFlexColumn}
        >
          {/* <Typography sx={displayFlex}>
            <ArrowDown height={9} width={9} />
          </Typography>
          <Typography>
            <Green />
            <Yellow />
            <Red />
          </Typography> */}
          <RateIcon />
        </Grid>
        <Grid
          style={{ color: '#000000' }}
          sx={{ ...poppins300, ...fontsize10 }}
          xs={9}
        >
          The accuracy of this estimate range is rate
          <span>
            <strong style={{ fontWeight: '600' }}> Medium. </strong>
          </span>
          <span>
            <Link href="a" style={{ ...medium }}>
              Learn more.
            </Link>
          </span>
        </Grid>
      </Grid>
    </Card>
  );
}

PredicationCard.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PredicationCard;
